;(function () {
    "use strict";

    function BAATCookieBanner() {
        var global = {
            analyticsScriptsLoaded: false,
            functionalScriptsLoaded: false,
            embeddedContentLoaded: false
        };

        var settings = {
            gtmCode: (typeof baatSiteSettings !== 'undefined' && baatSiteSettings.gtmCode) ? baatSiteSettings.gtmCode : ''
        };

        var fn = {
            init: function () {
                if (settings.gtmCode) {
                    fn.initGoogleTagManager();
                }

                if (
                    window.BMCookieConsent && 
                    typeof window.BMCookieConsent.preferenceGiven === 'function' && 
                    window.BMCookieConsent.preferenceGiven()
                ) {
                    var consent = window.BMCookieConsent.getPreferences();
                    fn.onConsentSelected(consent);
                }

                document.addEventListener('bmcc-consent-selected', function (e) {
                    fn.onConsentSelected(e.detail);
                });
            },

            onConsentSelected: function (consent) {
                if (consent.analytics && !global.analyticsScriptsLoaded) {
                    fn.enableGoogleAnalytics();
                    global.analyticsScriptsLoaded = true;
                }

                if (consent.necessary && !global.functionalScriptsLoaded) {
                    global.functionalScriptsLoaded = true;
                }

                if (consent.embeds && !global.embeddedContentLoaded) {
                    window.BMCookieConsent.loadEmbeddedContent();
                    global.embeddedContentLoaded = true;
                }
            },

            gtag: function () {
                window.dataLayer = window.dataLayer || [];
                dataLayer.push(arguments);
            },

            initGoogleTagManager: function () {
                if (!settings.gtmCode) {
                    console.error('No GTM code found');
                    return;
                }

                // Push initial consent settings with 'denied' for everything
                fn.gtag('consent', 'default', {
                    'ad_storage': 'denied',
                    'ad_user_data': 'denied',
                    'ad_personalization': 'denied',
                    'analytics_storage': 'denied',
                    'personalization_storage': 'denied',
                    'functionality_storage': 'denied',
                    'security_storage': 'denied'
                });

                // Load GTM script asynchronously
                (function (w, d, s, l, i) {
                    w[l] = w[l] || [];
                    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
                    var f = d.getElementsByTagName(s)[0],
                        j = d.createElement(s),
                        dl = l != 'dataLayer' ? '&l=' + l : '';
                    j.async = true;
                    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
                    f.parentNode.insertBefore(j, f);
                })(window, document, 'script', 'dataLayer', settings.gtmCode);
            },

            enableGoogleAnalytics: function () {
                fn.gtag('consent', 'update', {
                    'ad_storage': 'granted',
                    'ad_user_data': 'granted',
                    'ad_personalization': 'granted',
                    'analytics_storage': 'granted',
                    'personalization_storage': 'granted',
                    'functionality_storage': 'granted',
                    'security_storage': 'granted'
                });
            }
        };

        jQuery(fn.init);
    }

    new BAATCookieBanner();

})();
